import React from 'react';

import {
  Dialog,
  DialogContent,
  DialogHeader,
  Heading,
  Stack,
  Text,
} from '@eluve/components';

interface VideoWalkthroughModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const LOOM_VIDEO_EMBED_URL =
  'https://www.loom.com/embed/59419588e37f4eda8f9cbb1de362f472?sid=daa999a3-7089-4b4c-8f21-344b4f45c9ca';

export const VideoWalkthroughModal: React.FC<VideoWalkthroughModalProps> = ({
  isOpen,
  onClose,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent size="3xl" className="gap-0 p-2 md:p-4">
        <DialogHeader className="px-1 py-0.5 md:px-3 md:py-4">
          <Stack align="center" className="md:gap-4" gap={0}>
            <Heading responsive size="2xl">
              Welcome to Eluve
            </Heading>
            <Text
              className="px-0 pb-2 md:px-8 md:pb-0"
              color="secondary"
              responsive
              size="md"
              weight="regular"
            >
              Learn more about how to use Eluve with a 4min video walkthrough
              below
            </Text>
          </Stack>
        </DialogHeader>
        <Stack gap={4} className="p-0">
          <div className="relative aspect-video w-full">
            <iframe
              src={LOOM_VIDEO_EMBED_URL}
              allowFullScreen
              className="absolute top-0 left-0 size-full"
              title="Eluve Video Walkthrough"
            />
          </div>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};
